import { render, staticRenderFns } from "./accessDeny.vue?vue&type=template&id=732500bb&scoped=true"
import script from "./accessDeny.vue?vue&type=script&lang=js"
export * from "./accessDeny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732500bb",
  null
  
)

export default component.exports